import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { Upload } from 'lucide-react';
import { cn } from '@common/utils/cn';

interface UploadDropzoneProps {
  onSelect: (file: globalThis.File) => void;
  disabled?: boolean;
}

export function UploadDropzone({ onSelect, disabled }: UploadDropzoneProps) {
  const { t } = useTranslation('files');

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => files[0] && onSelect(files[0]),
    disabled,
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      className={cn(
        'border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors',
        isDragActive
          ? 'border-brand-primary bg-brand-primary-subtle'
          : 'border-border hover:border-border-strong',
        disabled && 'pointer-events-none opacity-50',
      )}
    >
      <input {...getInputProps()} />
      <Upload className="w-12 h-12 mx-auto mb-4 text-foreground-subtle" />
      {isDragActive ? (
        <p className="text-brand-primary font-medium">{t('dropHere')}</p>
      ) : (
        <div>
          <p className="text-foreground-muted mb-1">
            {t('dragOrClick')}{' '}
            <span className="text-brand-primary font-medium">{t('clickToSelect')}</span>
          </p>
          <p className="text-sm text-foreground-subtle">{t('allowedFormats')}</p>
        </div>
      )}
    </div>
  );
}
